import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingBoxComponent } from './components/loading-box/loading-box.component';
import { HeaderComponent } from './components/header/header.component';
import { AsksuiteCitrusModule } from 'asksuite-citrus';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NotificationToggleComponent } from './components/notification-toggle/notification-toggle.component';
import { PhoneToggleComponent } from './components/phone-toggle/phone-toggle.component';
import { ThemeToggleComponent } from '../modules/live-chat/components/theme-toggle/theme-toggle.component';
import { ThemeToggleHintComponent } from '../modules/live-chat/components/theme-toggle-hint/theme-toggle-hint.component';
import { ThemeToggleHintDirective } from '../modules/live-chat/components/theme-toggle-hint/theme-toggle-hint.directive';
import { OverlayModule } from '@angular/cdk/overlay';
import { ButtonV2Component } from 'asksuite-livechat-frontend-libs';
import { SharedModule } from '../shared/shared.module';
import { NotificationTooltipComponent } from '../modules/live-chat/components/notification-tooltip/notification-tooltip.component';
import { SpectatorModeComponent } from './components/spectator-mode/spectator-mode.component';
import { PhoneStatusConfirmationModalComponent } from './components/phone-status-confirmation-modal/phone-status-confirmation-modal.component';
import { CreditsBalanceModalComponent } from './components/credits-balance-modal/credits-balance-modal.component';
import { CreditsBalanceModalV2Component } from './components/credits-balance-modal-v2/credits-balance-modal-v2.component';
import { CreditsBalanceButtonComponent } from './components/credits-balance-button/credits-balance-button.component';
import { WhatsappCreditsAlertComponent } from './components/whatsapp-credits-alert/whatsapp-credits-alert.component';

@NgModule({
  declarations: [
    LoadingBoxComponent,
    HeaderComponent,
    NotificationToggleComponent,
    PhoneToggleComponent,
    ThemeToggleComponent,
    ThemeToggleHintComponent,
    ThemeToggleHintDirective,
    SpectatorModeComponent,
    NotificationTooltipComponent,
    PhoneStatusConfirmationModalComponent,
    CreditsBalanceModalComponent,
    CreditsBalanceModalV2Component,
    CreditsBalanceButtonComponent,
    WhatsappCreditsAlertComponent,
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatProgressBarModule,
    AsksuiteCitrusModule,
    TranslateModule,
    MatRippleModule,
    ButtonV2Component,
    OverlayModule,
    SharedModule,
  ],
  exports: [LoadingBoxComponent, HeaderComponent, WhatsappCreditsAlertComponent],
})
export class LayoutsModule {}
